<template>
    <div class="common-title-box" :class="{'dark': props.dark}">
        <div class="flex-start">
            <div class="common-title">{{title}}</div>
            <slot></slot>
        </div>
        <div v-show="props.total">
            <span class="prev" :class="{'dark': props.dark, 'disabled': props.pageIndex == 1}" @click="prev"><i class="iconfont icon-a-iconfenyeqi-zuo"></i></span>
            <span class="next" :class="{'dark': props.dark , 'disabled': props.pageIndex == 2}" @click="next"><i class="iconfont icon-fanye-you"></i></span>
        </div>
    </div>
</template>
<script setup>
    import { toRefs } from 'vue'
    const props = defineProps({
        title: {
            type: String,
            default: ''
        },
        dark: {
            type: Boolean,
            default: false
        },
        total: {
            type: Number,
            default: 0
        },
        pageIndex: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 4
        }
    })
    const { pageIndex, pageSize, total } = toRefs(props)
    const emit = defineEmits(['changePage'])

    const prev = () => {
        console.log('pageIndex', pageIndex.value)
        if(pageIndex.value>1) {
            let index = pageIndex.value - 1
            emit('changePage', index)
        }
    }
    const next = () => {
        console.log('pageIndex', pageIndex.value, pageIndex.value*pageSize.value<total.value)
        if(pageIndex.value*pageSize.value<total.value&&pageIndex.value<2) {
            let index = pageIndex.value + 1
            console.log('index', index)
            emit('changePage', index)
        }
    }

</script>

<style lang="scss" scoped>
    .common-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 40px;
        margin-bottom: 18px;
        &.dark {
            padding-top: 24px;
        }
        .common-title {
            font-size: 20px;
            font-weight: bold;
            color: #222222;
            line-height: 26px;
        }
        .prev, .next {
            display: inline-block;
            width: 28px;
            height: 28px;
            background: #f7f9fA;
            border-radius: 50%;
            font-size: 12px;
            text-align: center;
            line-height: 28px;
            color: #666666;
            cursor: pointer;
            &.disabled {
                background: #f7f9fA !important;
                color: #BBBBBB !important;
            }
            &:hover {
                background: #EEF5FF;
                color: var(--common-home-main-color);
            }
            &.dark {
                background: #FFFFFF;
                &:hover {
                    background: #FFFFFF;
                    color: var(--common-home-main-color);
                }
                &.disabled {
                    background: #FFFFFF !important;
                    color: #BBBBBB !important;
                }
            }
            
        }
        .next {
            margin-left: 12px;
        }
    }
</style>
